import * as React from "react"
import {Box, Divider, Typography} from "@mui/material";
import {IconSeeker, SelectSeeker, TextFieldSeeker} from "@ui-seeker/core";

import {ActionButton} from "@components";
import {productPageKpiFilters} from "../@signals";


export default function ConditionsBlock({ conditions, deleteCondition, addCondition, updateCondition }) {

    return <Box>
        <Typography variant='subtitle1'>
            Conditions KPIs Percentages
        </Typography>

        <Divider sx={{ bgcolor: 'primary.light', height: 1, fontWeight: 'bold', mb: 4 }} />

        <Box display='flex' flexWrap='wrap' alignItems='center' justifyContent='center' gap={3}>
            {conditions.map((condition, index) => (
                <Box sx={{ border: '1px solid lightgray', borderRadius: 3, mb: 2.5, p: 2, pt: 3, minWidth: 300 }} key={index}>
                    <Box display="flex" justifyContent="space-between">
                        <Typography variant="subtitle1">Condition {index + 1}</Typography>
                        <IconSeeker
                            icon="xmark"
                            tooltip='Delete Execution'
                            onClick={() => deleteCondition(condition.id)}
                            sx={{ color: 'primary.main', fontSize: '1.5rem' }}
                        />
                    </Box>
                    <Divider sx={{ bgcolor: 'disabled.light', fontWeight: 'bold', mb: 3 }} />
                    <SelectSeeker
                        options={productPageKpiFilters.value}
                        multiple={false}
                        label="KPI"
                        value={condition.kpi || null}
                        onChange={e => updateCondition(condition.id, {kpi: e.target.value})}
                        sx={{ mb: 1 }}
                    />
                    <TextFieldSeeker
                        label="Minimum KPI % Value"
                        size="small"
                        type="number"
                        value={condition.value}
                        onChange={e => {
                            if (e.target.value > 100)
                                e.target.value = 100

                            if (e.target.value < 0)
                                e.target.value = 0

                            updateCondition(condition.id, {value: e.target.value})
                        }}
                        icon="pen-to-square"
                    />
                </Box>
            ))}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center'}}>
            <ActionButton
                label="Add new Condition"
                icon="plus"
                onClick={addCondition}
                sx={{ mb: 4, mt: 1 }}
            />
        </Box>
    </Box>
}